import type { ToolPostPayload } from "@repo/app-types/entities/tool";
import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import {
  SlideoverDialogButtons,
  SlideoverDialogContent,
} from "@repo/ui/Slideover/slideoverDialog";
import type { FC } from "react";
import { useToolForm, type FormTool } from "../../tools/hooks/useToolForm.js";

export interface ToolEditorSlideoverDialogContentProps {
  tool: FormTool;
  onRemoveFromAgent: (toolId: string) => void;
  onCancel: () => void;
  onSave: (payload: ToolPostPayload) => Promise<void>;
}

export const ToolEditorSlideoverDialogContent: FC<
  ToolEditorSlideoverDialogContentProps
> = (props) => {
  const { isFormValid, hasChanges, isSaving, onSave, renderForm } = useToolForm(
    {
      type: props.tool.type,
      initialData: props.tool,
      onSave: props.onSave,
    },
  );

  return (
    <>
      <SlideoverDialogContent>
        <div className="flex flex-col space-y-3 p-4">{renderForm()}</div>
      </SlideoverDialogContent>
      <SlideoverDialogButtons>
        <Button
          variant={ButtonVariant.Warning}
          onClick={() => props.onRemoveFromAgent(props.tool.id)}
        >
          Remove from agent
        </Button>

        {/* Spacer until we have a better way to have left-aligned buttons in SlideoverDialogButtons. */}
        <div className="flex flex-auto"></div>

        <Button
          variant={ButtonVariant.Secondary}
          onClick={props.onCancel}
          isDisabled={isSaving}
        >
          Cancel
        </Button>
        <Button
          variant={ButtonVariant.Primary}
          onClick={onSave}
          isDisabled={!hasChanges || !isFormValid || isSaving}
          isLoading={isSaving}
        >
          Save and publish
        </Button>
      </SlideoverDialogButtons>
    </>
  );
};
